import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import { ensureReportAuth } from './core/reportAuth'
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import { convertCompilerOptionsFromJson } from 'typescript';
import 'firebase/storage'; 
export default {
  namespaced: true,
  state: {
    modalCoachingData: [],
    inforDailyData: [],
    inforWeeklyData: [],
    loadingDailyReportStatus: false,
    loadingWeeklyReportStatus: false,
    organize: [],
    userData: {},
    questionData: {},
    datamultichoices:[],
    datamultichoices2:[],
    countmultichoices:0,
    multipleCard: false,
    yesnoCard: false,
    scaleCard: false,
    answerOpt: [],
    orderColor: [],
    organizations: [],
    yes: false,
    datalistall: [],
    messages: [],
    response: [],
    teamHeight: '',
    teamsall: [],
    scaleCardLoading: false,
    yesnoCardLoading: false,
    multipleCardLoading: false,
  },
  mutations: {
    setTeamHeight(state: any, value: any) {
      state.teamHeight = value
    },
    setAllTeam(state: any, value: any) {
        state.teamsall = value
      },
    setInforDailyData(state:any, result:any) {
        state.inforDailyData = result
    },
    setInforWeeklyData(state:any, result:any) {
        state.inforWeeklyData = result
    },
    setloadingDailyReportStatus(state:any, result:any) {
        state.loadingDailyReportStatus = result
    },
    setloadingWeeklyReportStatus(state:any, result:any) {
        state.loadingWeeklyReportStatus = result
    },
    setMultipleCardLoading(state:any, result:any) {
        state.multipleCardLoading = result
    },
    setYesnoCardLoading(state:any, result:any) {
        state.yesnoCardLoading = result
    },
    setScaleCardLoading(state:any, result:any) {
        state.scaleCardLoading = result
    },
    setOrganizeTeam(state:any,result:any){
        state.organize = result
    },
    setUserData(state:any,result:any){
        state.userData = result
    },
    setQuestionData(state:any,result:any){
        state.questionData = result
    },
    setMessages(state:any,result:any){
        state.messages = result
    },
    setDataMultiChoices(state:any,result:any){
        state.datamultichoices = result
    },
    setCountMultiChoices(state:any,result:number){
        state.countmultichoices = result
    },
    setMultipleCard(state:any,result:number){
        state.multipleCard = result
    },
    setYesNoCard(state:any,result:number){
        state.yesnoCard = result
    },
    setScaleCard(state:any,result:number){
        state.scaleCard = result
    },
    setAnswerOption(state:any,result:any){
        state.answerOpt = result
    },
    setOrderColor(state:any,result:any){
        state.orderColor = result
    },
    setOrganizations(state: any, value: any) {
        state.organizations = value
    },
    setYes(state: any, result: any) {
        state.yes = result
    },
    setDataTableAll(state: any, value: any) {
        state.datalistall = value
    },
  },
  actions: {
    async getDataPreview({ commit, state }: any, form: any) {
        commit(`setloading${form.loading}ReportStatus`, true)
        commit(`setInfor${form.loading}Data`, {})
        await ensureReportAuth();
        const inforData = {};
        let dataPreview:Array<any> = [];
        firebase.firestore().collection('sendemail').where("email", "==", form.user).where("date", "==", form.date).where("type", "==", form.type).get()
        .then(async (querySnapshot)=> {
            if(querySnapshot.empty){
                inforData['deliveryStatus'] = ''
                inforData['readStatus'] = ''
                inforData['preview'] = ''
                commit(`setInfor${form.loading}Data`, inforData)
                commit(`setloading${form.loading}ReportStatus`, false)
                
            }else{
                querySnapshot.forEach(function (doc) {
                    const _data = doc.data()
                    if(_data.file){
                        dataPreview.push(_data)
                    }
                    if(_data.trackOpen==false) firebase.firestore().collection(`sendemail`).doc( doc.id).update({trackOpen:true})
                });
                if(dataPreview.length > 0){
                    dataPreview = _.orderBy(dataPreview,['createdate'], ['asc'])
                    let _data = dataPreview[dataPreview.length - 1]
                    const k_user = form.user.replace(/\./g, "||")
                    const user = (await firebase.database().ref(`/users/${k_user}`).once('value')).val()
                    const fullname = user.firstname + " " + user.lastname
                    inforData['deliveryStatus'] = 'delivered' // Now Fix delivery Only
                    if(_data.trackOpen && _data.trackOpen == true && _data.readdate){
                        inforData['readStatus'] = 'Opened by ' + fullname + ' on ' + format(_data.readdate, 'MMMM D, YYYY [at] H:mm A')
                    }else{
                        inforData['readStatus'] = ''
                    }
                    inforData['preview'] = ''
                    firebase.storage().ref(`${_data.file}`).getDownloadURL().then(downloadURL => {
                        if(downloadURL !== undefined && downloadURL !== ''){
                            //if(form.type === 'report_daily_boss'){
                                fetch(downloadURL)
                                .then( r => r.text() )
                                .then((t) => {
                                    const regex = /<div style="margin: 40px 40px 0 40px; font-family: 'Lato', Tahoma, Verdana, Segoe, sans-serif; line-height:24px; font-family:'Lato', Tahoma, Verdana, Segoe, sans-serif; text-align:center;">(.|\n)*?<\/div>/g;
                                    const found = t.match(regex);
                                    for(const x in found){
                                        t = t.replace(found[x],''); 
                                    }
                                    const regex2 = /<div style="margin: 18px 0; font-family: 'Lato', Tahoma, Verdana, Segoe, sans-serif; line-height:24px; font-family:'Lato', Tahoma, Verdana, Segoe, sans-serif; text-align:center;">(.|\n)*?<\/div>/g;
                                    const found2 = t.match(regex2);
                                    for(const x in found2){
                                        t = t.replace(found2[x],''); 
                                    }
                                    // let found2;
                                    // if(!found){
                                    //     const regex2 = /<div style="font-size:12px;line-height:14px;color:#FFF;font-family:\'Lato\', Tahoma, Verdana, Segoe, sans-serif;text-align:center;"><p style="margin: 0;font-size: 14px;line-height: 17px">(.|\n)*?<\/p><\/div>/g;
                                    //     found2 = t.match(regex2);
                                    //     for(const x in found2){
                                    //         const sp = found2[x].split(' - ');
                                    //         let text = '';
                                    //         for(let i = 0; i < sp.length; i++){
                                    //             if(i == (sp.length-1)){
                                    //                 text += '</p></div>';
                                    //             }else{
                                    //                 text += sp[i];
                                    //             }
                                    //         }
                                    //         t = t.replace(found2[x],text); 
                                    //     }
                                        
                                    // }
                                    // if(!found && !found2){
                                    //     const regex2 = /<div class="text-response" style="margin: 24px 3.6rem 0; font-family: \'Lato\', Tahoma, sans-serif; color: #fff; font-size: 14px;">(.|\n)*?<\/div>/g;
                                    //     found2 = t.match(regex2);
                                    //     for(const x in found2){
                                    //         const sp = found2[x].split(' - ');
                                    //         let text = '';
                                    //         for(let i = 0; i < sp.length; i++){
                                    //             if(i == (sp.length-1)){
                                    //                 text += '</div>';
                                    //             }else{
                                    //                 text += sp[i];
                                    //             }
                                    //         }
                                    //         t = t.replace(found2[x],text); 
                                    //     }
                                    // }
                                    inforData['preview'] = t
                                    commit(`setInfor${form.loading}Data`, inforData)
                                    commit(`setloading${form.loading}ReportStatus`, false)
                                })
                                .catch(() => {
                                    // Storage fetch blocked (e.g. CORS on a non-whitelisted
                                    // origin like localhost) or unreachable — surface what we
                                    // have instead of leaving the spinner stuck forever.
                                    commit(`setInfor${form.loading}Data`, inforData)
                                    commit(`setloading${form.loading}ReportStatus`, false)
                                })
                            // }else{
                            //     inforData['preview'] = downloadURL
                            //     commit(`setInfor${form.loading}Data`, inforData)
                            //     commit(`setloading${form.loading}ReportStatus`, false)
                            // }
                        }
                    }).catch(function () {
                        // getDownloadURL failed (missing file / permission) — don't hang the spinner.
                        commit(`setInfor${form.loading}Data`, inforData)
                        commit(`setloading${form.loading}ReportStatus`, false)
                    });
                }else{
                    inforData['deliveryStatus'] = ''
                    inforData['readStatus'] = ''
                    inforData['preview'] = ''
                    commit(`setInfor${form.loading}Data`, inforData)
                    commit(`setloading${form.loading}ReportStatus`, false)
                }
            }
        });
    },
    async getDataQuestionDetail({ commit, state, dispatch }: any, form: any) {
        await ensureReportAuth();
        let emailKey = form.user.replace(/\./g, "||")
        // user and question are independent (quest_id comes from the URL
        // token, not the user record) — fetch both at once.
        const [userSnap, questionSnap] = await Promise.all([
            firebase.database().ref(`/users/${emailKey}`).once('value'),
            firebase.database().ref(`/questions/${form.quest_id}`).once('value'),
        ])
        const user = userSnap.val()
        commit('setUserData',user)
        const tablePromise = dispatch('getDataTable', user)
        const question = questionSnap.val()
        if(user.language == 'th'){
            question.question_name = question.question
        }else{
            question.question_name = question.question_en
        }
        if(question.type == 'Multiple Choice'){
            if(question.m_choice.en.length==2)
            {
                if(question.m_choice.en[0].toUpperCase()==="YES"&&question.m_choice.en[1].toUpperCase()==="NO")
                {
                    question.type_name = 'Yes/No'
                }
                else if(question.m_choice.en[1].toUpperCase()==="YES"&&question.m_choice.en[0].toUpperCase()==="NO")
                {
                    question.type_name = 'Yes/No'
                }
                else{
                    question.type_name = 'Multiple Choice'
                    question.custom_type="multiple_choice"}
            }else{
                question.type_name = 'Multiple Choice'
                question.custom_type="multiple_choice"
            }

        }
        // else if(question.type == 'Text Area Field'){
        //     question.type_name = 'Open-ended'
        // }
        else{
            question.type_name = question.type
        }
        if(question.type === 'Multiple Choice'){
            if(question.custom_type == 'multiple_choice'){
                commit('setMultipleCard', true)
                commit('setMultipleCardLoading',true)
            }else{
                commit('setYesNoCard', true)
                commit('setYesnoCardLoading',true)
            }
        } else if(question.type === 'Scale'){
            commit('setScaleCard', true)
            commit('setScaleCardLoading',true)
        }
        commit('setQuestionData',question)
        // Everything below only needs user.company — start all remaining
        // reads now and let processing wait where it must.
        const usersQuestionsPromise = firebase.firestore().collection('users_questions').where('company','==',user.company).where('date','==',form.date).where('quest_id','==',form.quest_id).where('status','==','close').get()
        const companyPromise = firebase.database().ref(`company/${user.company}`).once('value')
        const [momSnapshot, orgSnapshot] = await Promise.all([
            firebase.firestore().collection('organization_mom').where("company", "==", user.company).get(),
            firebase.firestore().collection('organization').where("company", "==", user.company).get(),
        ])
        const teams: string[] = []
        momSnapshot.forEach((doc)=> {
            teams[doc.data().team] = doc.data().mom;
        });
        commit('setOrganizeTeam', teams)
        const organizations: Array<any> = [];
        orgSnapshot.forEach((doc) => {
            const organization = doc.data()
            organization.key = doc.id
            organizations[organization.team_id] = organization
        });
        commit('setOrganizations', organizations)
        if(question.type === 'Multiple Choice'){
            if(question.custom_type){
                if(form.quest_id !== '-L1FmpFO-v8IZc_B5EB7' && question.m_choice.weight[0] === "0" || question.m_choice.weight[0] === 0){
                    commit('setAnswerOption', question.m_choice[user.language].reverse())
                    commit('setYes', false)
                }else{
                    commit('setAnswerOption', question.m_choice[user.language])
                    commit('setYes', true)
                }
            }else{
                if(question.m_choice.weight[0] === "0" || question.m_choice.weight[0] === 0){
                    if(question.flip=="Y"){
                        commit('setAnswerOption', question.m_choice[user.language].reverse())
                    }else{
                        commit('setAnswerOption', question.m_choice[user.language])
                    }
                    commit('setYes', false)
                }else{
                    if(question.flip=="Y"){
                        commit('setAnswerOption', question.m_choice[user.language].reverse())
                    }else{
                        commit('setAnswerOption', question.m_choice[user.language])
                    }
                    commit('setYes', true)
                }
            }
            if (state.answerOpt.length > 0) {
                let orderColor: Array<any> = [];
                if (state.answerOpt.length == 2) {
                  orderColor = [4, 2];
                } else if (state.answerOpt.length == 3) {
                  orderColor = [4, 3, 2];
                } else if (state.answerOpt.length == 4) {
                  orderColor = [5, 4, 3, 2];
                } else {
                  let no = state.answerOpt.length;
                  for (var i = state.answerOpt.length; i > 0; i--) {
                    orderColor.push(no);
                    no = no - 1;
                  }
                }
                commit('setOrderColor', orderColor)
              }
            // The tree build reads datalistall/teamHeight from getDataTable —
            // make sure that query has landed before dispatching it.
            await tablePromise
            if(state.questionData.custom_type == 'multiple_choice'){  // Multiple Choice (Other) type
                form.enableCard = 'Multiple Choice'
                form.question = question
                form.usersQuestionsPromise = usersQuestionsPromise
                form.companyPromise = companyPromise
                dispatch('getDataMultiChoicesOther', form)
            }else{  // Yes/no Type
                form.enableCard = 'Yes/No'
                form.usersQuestionsPromise = usersQuestionsPromise
                form.companyPromise = companyPromise
                dispatch('getDataMultiChoices', form)
            }
        } else if(question.type === 'Scale'){
            form.enableCard = 'Scale'
            form.usersQuestionsPromise = usersQuestionsPromise
            form.companyPromise = companyPromise
            await tablePromise
            dispatch('getDataScale', form)
        }
    },
    async getDataMultiChoices({commit, state, dispatch}:any,form:any){
        const teams = state.organize;
        const querySnapshot = form.usersQuestionsPromise
            ? await form.usersQuestionsPromise
            : await firebase.firestore().collection('users_questions').where('company','==',state.userData.company).where('date','==',form.date).where('quest_id','==',form.quest_id).where('status','==','close').get()
        const messages : number[][] = []
        querySnapshot.forEach((doc: any) => {
            if (doc.data().answer !== undefined && doc.data().team) {
                if(messages[doc.data().team] === undefined){
                    messages[doc.data().team] = []
                    messages[doc.data().team][0] = 0;
                    messages[doc.data().team][1] = 0;
                }
                messages[doc.data().team][doc.data().answer]++
                if(teams[doc.data().team]){
                    for(const x in teams[doc.data().team]){
                        const team = teams[doc.data().team][x];
                        if(messages[team] === undefined){
                            messages[team] = []
                            messages[team][0] = 0;
                            messages[team][1] = 0;
                        }
                        messages[team][doc.data().answer]++
                    }
                }
            }
        });
        commit('setMessages',messages)
        dispatch('getDataTablebyTeam', { team: state.userData.team, type: 'parent', firstTime: true, enableCard: form.enableCard, companyPromise: form.companyPromise })
    },
    async getDataMultiChoicesOther ({commit, state, dispatch}:any,form:any){
        const teams = state.organize;
        // getDataQuestionDetail already fetched the question — the second
        // RTDB read only remains as a fallback for callers that pass none.
        const question = form.question || (await firebase.database().ref(`/questions/${form.quest_id}`).once('value')).val();
        const querySnapshot = form.usersQuestionsPromise
            ? await form.usersQuestionsPromise
            : await firebase.firestore().collection('users_questions').where('company','==',state.userData.company).where('date','==',form.date).where('quest_id','==',form.quest_id).where('status','==','close').get()
        const messages : number[][] = []
        querySnapshot.forEach((doc: any) => {
            if (doc.data().answer !== undefined && doc.data().team) {
                if(messages[doc.data().team] === undefined){
                    messages[doc.data().team] = []
                    if(question && question.m_choice){
                        for(const k in question.m_choice[state.userData.language]){
                            messages[doc.data().team][k] = 0
                        }
                    }
                }
                messages[doc.data().team][doc.data().answer]++

                if(teams[doc.data().team]){
                    for(const x in teams[doc.data().team]){
                        const team = teams[doc.data().team][x];
                        if(messages[team] === undefined){
                            messages[team] = []
                            if(question && question.m_choice){
                                for(const k in question.m_choice[state.userData.language]){
                                    messages[team][k] = 0
                                }
                            }
                        }
                        messages[team][doc.data().answer]++
                    }
                }
            }
        });
        if(question.m_choice.weight[0] === '0' || question.m_choice === 0){
        }else{
            for(const x in messages) {
                messages[x] = messages[x].reverse()
            }
        }
        commit('setMessages',messages)
        dispatch('getDataTablebyTeam', { team: state.userData.team, type: 'parent', firstTime: true, enableCard: form.enableCard, companyPromise: form.companyPromise })
    },
    async getDataScale({commit, state, dispatch}:any,form:any) {
        const teams = state.organize;
        const querySnapshot = form.usersQuestionsPromise
            ? await form.usersQuestionsPromise
            : await firebase.firestore().collection('users_questions').where('company','==',state.userData.company).where('date','==',form.date).where('quest_id','==',form.quest_id).where('status','==','close').get()
        const messages : number[][] = []
        const scale : number[][] = []
        let i = 0;
        querySnapshot.forEach((doc: any) => {
            if (doc.data().answer !== undefined && doc.data().team) {
                i++;
                if(messages[doc.data().team] === undefined){
                    messages[doc.data().team] = []
                }
                if(messages[doc.data().team][doc.data().answer] === undefined){
                    messages[doc.data().team][doc.data().answer] = 0
                }
                messages[doc.data().team][doc.data().answer]++

                if(teams[doc.data().team]){
                    for(const x in teams[doc.data().team]){
                        const team = teams[doc.data().team][x];
                        if(messages[team] === undefined){
                            messages[team] = []
                        }
                        if(messages[team][doc.data().answer] === undefined){
                            messages[team][doc.data().answer] = 0
                        }
                        messages[team][doc.data().answer]++
                    }
                }
            }
        });
        for(const x in messages) {
            if(scale[x] === undefined){
                scale[x] = []
            }
            let no = 0
            for(const y in messages[x]){
                if(scale[x]['total'] === undefined){
                    scale[x]['total'] = 0
                    scale[x]['range'] = new Array()
                    scale[x]['range'][0] = 0
                    scale[x]['range'][1] = 0
                    scale[x]['range'][2] = 0
                }
                if(Number(y) > 0 && Number(y) < 7){
                    scale[x]['range'][0] += Number(messages[x][y])
                }else if(Number(y) > 6 && Number(y) < 9){
                    scale[x]['range'][1] += Number(messages[x][y])
                }else if(Number(y) > 8){
                    scale[x]['range'][2] += Number(messages[x][y])
                }
                scale[x]['total'] += (Number(y) * Number(messages[x][y]))
                no += Number(messages[x][y])
            }
            scale[x]['avg'] = scale[x]['total'] / no > 0 ? Number((scale[x]['total'] / no).toFixed(1)) : 0

        }
        commit('setMessages',scale)
        dispatch('getDataTablebyTeamScale', { team: state.userData.team, type: 'parent', firstTime: true, enableCard: form.enableCard, companyPromise: form.companyPromise })
    },
    async getDataTable({ commit, dispatch, state, rootState }: any,user:any) {
        const teams: Array<any> = [];
        const allTeam: Array<any> = [];
        let teamHeight:any
        let topmostArr: Array<any> = [];
        await firebase.database().ref('team').orderByChild('company').equalTo(`${user.company}`).once('value', snapshot => {
            snapshot.forEach((doc): any => {
                const team = doc.val()
                team.key = doc.key
                if (!doc.val().parent){
                    topmostArr.push(doc.key)
                }
                allTeam[team.key] = team
                teams.push(team)
            });
            teamHeight = topmostArr[0]
            if(topmostArr.length > 1){
                teamHeight = _.find(topmostArr, (value) => {
                    const chk_topmost = _.find(teams, { parent: value });
                    return !!chk_topmost;
                });
            }
            commit('setTeamHeight',teamHeight)
            commit('setAllTeam',allTeam)
        });
        if (teams.length > 0) {
          const response: Array<any> = [];
          const data: { [key: string]: {} } = {};
          for (let i = 0; i < teams.length; i++) {
            data[teams[i].key] = {
              id: teams[i].key,
              team: teams[i].name,
            }
            response.push(data[teams[i].key])
          } 
          commit('setDataTableAll', _.sortBy(response, [function (o: any) { return o.team; }]))
        }
      },
    async getDataTablebyTeam({ commit, state, dispatch, rootState }: any, data: any) {
        const company = (data.companyPromise
            ? await data.companyPromise
            : await firebase.database().ref(`company/${state.userData.company}`).once('value')).val()
        const organizations = state.organizations
        // Fill one team row (shared object from datalistall) and recurse into
        // its sub-teams. All inputs are already in state — the old version's
        // staggered self-dispatches and 1s pre-commit sleep were pure wait.
        const fillTeam = (teamId: any): any => {
            const row = _.filter(state.datalistall, { 'id': teamId })[0]
            if (!row) return null
            row['children'] = new Array()
            row['value'] = new Array()
            _.forEach(state.messages[teamId], (value: any) => {
                row['value'].push(value)
            });
            const org = organizations[teamId]
            if (org !== undefined) {
                _.forEach(org.parent, (child: any) => {
                    if (child.team_id) {
                        const childRow = fillTeam(child.team_id)
                        if (childRow) row['children'].push(childRow)
                    }
                });
            }
            return row
        }
        const response: Array<any> = []
        const teamRow = fillTeam(data.team)
        if (teamRow) response.push(teamRow)
        let i: any = 0
        _.forEach(state.messages[data.team], (value: any) => {
            i += value
        });
        if (data.type == 'parent') {
            const overallData: Array<any> = [];
            overallData['id'] = 'overall'
            overallData['team'] = (company && company.name) ? company.name : 'Overall'
            overallData['children'] = new Array()
            overallData['value'] = new Array()
            _.forEach(state.messages[state.teamHeight], (value: any) => {
                overallData['value'].push(value)
            });
            response.unshift(overallData)
            commit('setDataMultiChoices',response)
            commit('setCountMultiChoices', i)
            if(data.enableCard == 'Yes/No'){
                commit('setYesnoCardLoading', false)
            }else if(data.enableCard == 'Multiple Choice'){
                commit('setMultipleCardLoading', false)
            }
        }
      },
      async getDataTablebyTeamScale({ commit, state, dispatch, rootState }: any, data: any) {
        const company = (data.companyPromise
            ? await data.companyPromise
            : await firebase.database().ref(`company/${state.userData.company}`).once('value')).val()
        const organizations = state.organizations
        // Same synchronous build as getDataTablebyTeam, over range/avg.
        const fillTeam = (teamId: any): any => {
            const row = _.filter(state.datalistall, { 'id': teamId })[0]
            if (!row) return null
            row['children'] = new Array()
            row['range'] = new Array()
            if(state.messages[teamId]){
                row['avg'] = state.messages[teamId].avg
                _.forEach(state.messages[teamId].range, (value: any) => {
                    row['range'].push(value)
                });
            }
            const org = organizations[teamId]
            if (org !== undefined) {
                _.forEach(org.parent, (child: any) => {
                    if (child.team_id) {
                        const childRow = fillTeam(child.team_id)
                        if (childRow) row['children'].push(childRow)
                    }
                });
            }
            return row
        }
        const response: Array<any> = []
        const teamRow = fillTeam(data.team)
        if (teamRow) response.push(teamRow)
        let i: any = 0
        if(state.messages[data.team]){
            _.forEach(state.messages[data.team].range, (value: any) => {
                i += value
            });
        }
        if (data.type == 'parent') {
            const overallData: Array<any> = [];
            overallData['id'] = 'overall'
            overallData['team'] = (company && company.name) ? company.name : 'Overall'
            overallData['children'] = new Array()
            overallData['range'] = new Array()
            if(state.messages[state.teamHeight]){
                overallData['avg'] = state.messages[state.teamHeight].avg
                _.forEach(state.messages[state.teamHeight].range, (value: any) => {
                    overallData['range'].push(value)
                });
            }
            response.unshift(overallData)
            commit('setDataMultiChoices',response)
            commit('setCountMultiChoices', i)
            commit('setScaleCardLoading', false)
        }
      },
  },
  getters: {
    datalistall : (state:any) => {
        return state.datalistall
    },
    userData : (state:any) => {
        return state.userData
    },
    teamHeight : (state:any) => {
        return state.teamHeight
    },
    inforDailyData : (state:any) => {
        return state.inforDailyData
    },
    inforWeeklyData : (state:any) => {
        return state.inforWeeklyData
    },
    loadingDailyReportStatus : (state:any) => {
        return state.loadingDailyReportStatus
    },
    loadingWeeklyReportStatus : (state:any) => {
        return state.loadingWeeklyReportStatus
    },
    loadingDailyDetailStatus : (state:any) => {
        return state.loadingDailyDetailStatus
    },
    datamultichoices:(state:any) => {
        return state.datamultichoices
    },
    countmultichoices:(state:any) => {
        return state.countmultichoices
    },
    yesnoCard:(state:any) => {
        return state.yesnoCard
    },
    multipleCard:(state:any) => {
        return state.multipleCard
    },
    scaleCard:(state:any) => {
        return state.scaleCard
    },
    questionData:(state:any) => {
        return state.questionData
    },
    answerOpt:(state:any) => {
        return state.answerOpt
    },
    orderColor:(state:any) => {
        return state.orderColor
    },
    yes:(state:any) => {
        return state.yes
    },
    scaleCardLoading:(state:any) => {
        return state.scaleCardLoading
    },
    yesnoCardLoading:(state:any) => {
        return state.yesnoCardLoading
    },
    multipleCardLoading:(state:any) => {
        return state.multipleCardLoading
    },
  }
}